<template>
  <div class="callback-view">
    <div class="callback-container">
      <div v-if="isProcessing" class="processing">
        <div class="spinner"></div>
        <h2>Verbinde mit Spotify...</h2>
        <p>Einen Moment bitte</p>
      </div>

      <div v-else-if="success" class="success">
        <div class="success-icon">✓</div>
        <h2>Erfolgreich verbunden!</h2>
        <p>Du wirst weitergeleitet...</p>
      </div>

      <div v-else class="error">
        <div class="error-icon">✕</div>
        <h2>Verbindung fehlgeschlagen</h2>
        <p>{{ errorMessage }}</p>
        <PrimaryButton @click="goHome">
          Zurück zur Startseite
        </PrimaryButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useSpotifyAuth } from '@/composables/useSpotifyAuth';
import PrimaryButton from '@/components/UI/PrimaryButton.vue';

const router = useRouter();
const { handleCallback } = useSpotifyAuth();

const isProcessing = ref(true);
const success = ref(false);
const errorMessage = ref('');

async function processCallback() {
  try {
    const result = await handleCallback(); // NEUE PKCE-Version

    if (result) {
      success.value = true;
      // Kurze Verzögerung für UX, dann redirect
      setTimeout(() => {
        // Wenn du direkt ins Spiel willst, nimm '/game'
        router.replace('/'); 
      }, 1500);
    } else {
      success.value = false;
      errorMessage.value = 'Die Anmeldung bei Spotify ist fehlgeschlagen.';
    }
  } catch (error) {
    success.value = false;
    errorMessage.value =
      error instanceof Error ? error.message : 'Unbekannter Fehler beim Spotify-Login';
  } finally {
    isProcessing.value = false;
  }
}

function goHome() {
  router.replace('/');
}

onMounted(() => {
  // WICHTIG: PKCE liest jetzt ?code=...&state=... aus window.location.search
  processCallback();
});
</script>
